// League join and round entry submission callables.
import { httpsCallable } from 'firebase/functions';
import type { DuelPick, Entry, Membership, Prediction } from '@h2h/shared';
import { functions } from '../firebase';

export interface JoinLeagueResult {
  ok: true;
  membership: Membership;
}

/** Join a league. Creates the per-league membership and groups the user if a round is OPEN. */
export async function joinLeague(leagueId: string): Promise<JoinLeagueResult> {
  const call = httpsCallable<{ leagueId: string }, JoinLeagueResult>(functions, 'joinLeague');
  const res = await call({ leagueId });
  return res.data;
}

export interface SubmitEntryInput {
  leagueId: string;
  roundId: string;
  predictions: Prediction[];
}

export interface SubmitEntryResult {
  ok: true;
  entry: Entry;
}

/** Submit (or edit) the player's entry for a round. Server validates and enforces locks. */
export async function submitEntry(input: SubmitEntryInput): Promise<SubmitEntryResult> {
  const call = httpsCallable<SubmitEntryInput, SubmitEntryResult>(functions, 'submitEntry');
  const res = await call(input);
  return res.data;
}

export interface SubmitCyclingEntryInput {
  leagueId: string;
  roundId: string;
  duelPicks: DuelPick[];
}

/**
 * Submit (or edit) the player's CYCLING stage entry — one binary A/B call per duel
 * on the slate, with a confidence permutation. Server validates and enforces the
 * whole-stage (EXACT) lock at the stage depart, exactly like football's submitEntry.
 */
export async function submitCyclingEntry(input: SubmitCyclingEntryInput): Promise<SubmitEntryResult> {
  const call = httpsCallable<SubmitCyclingEntryInput, SubmitEntryResult>(functions, 'submitCyclingEntry');
  const res = await call(input);
  return res.data;
}
